import React, {Component, Fragment} from "react";
import DataTableForm from "../Components/Forms";
import {_getShow, _patch} from "../Api";
import {
    Form,
    Button,
    UncontrolledAlert, Label
} from "reactstrap";
import Loader from "../Components/Loader";
import {imgPath} from "../Helpers";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faPencilAlt,
    faWindowClose,
    faCloudUploadAlt
} from '@fortawesome/free-solid-svg-icons'

class View extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: {},
            successMessage: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.queryAPI();
    }

    queryAPI() {
        _getShow(this.props.db, this.props.id).then(res => {
            this.setState({
                formEdit: res.data.show,
                fields: res.data.fields
            })
        })
    }

    handleSubmit(e) {
        e.preventDefault();
        _patch(this.props.db, this.props.item, this.state.formEdit).then(res => {
            if (res.error && res.error === 200) {
                this.setState({
                    errorMessage: res.messages
                })
                setTimeout(
                    () => this.setState({errorMessage: {}}),
                    3000
                );
            }
            if (res.result === 'success') {
                this.setState({
                    successMessage: "Your data has been saved"
                })
                setTimeout(
                    () => this.setState({successMessage: false}),
                    3000
                );
            }

        })
    }

    handleChange(e) {
        const formEdit = this.state.formEdit;
        formEdit[e.target.name] = e.target.value
        this.setState({
            formEdit: formEdit
        })
    }

    render() {

        return (
            <Fragment>
                {(this.state.formEdit && this.state.fields) ?
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-body">
                                        {Object.values(this.state.errorMessage).map((error, i) => {
                                            return (
                                                <UncontrolledAlert
                                                    color="danger"
                                                    className="alert-dismissible fade show"
                                                    role="alert"
                                                    key={i}>
                                                    <i className="mdi mdi-block-helper me-2"> </i>
                                                    {error}
                                                </UncontrolledAlert>
                                            )
                                        })}
                                        {this.state.successMessage &&
                                        <UncontrolledAlert
                                            color="success"
                                            className="alert-dismissible fade show"
                                            role="alert">
                                            <i className="mdi mdi-check-all me-2"> </i> {this.state.successMessage}
                                        </UncontrolledAlert>
                                        }

                                        {this.state.editStatus &&
                                        <div>
                                            <h4 className="card-title">Edit</h4>
                                            <p className="card-title-desc">&nbsp;</p>
                                            <Form onSubmit={this.handleSubmit}>
                                                {this.state.fields ? this.state.fields.map((field, i) => {
                                                    return (
                                                        <DataTableForm {...this.props}
                                                                       key={i}
                                                                       fields={field}
                                                                       formEdit={this.state.formEdit}
                                                                       onChange={this.handleChange}
                                                                       itemValue={this.state.formEdit[field.name]}/>)
                                                }) : null}
                                                <div className="row mb-3">
                                                    <div className="col-sm-2 col-4 col-form-label">&nbsp;</div>
                                                    <div className="col-sm-10 col-8">
                                                        <Button outline
                                                                color="primary"
                                                                className="me-2">
                                                            <FontAwesomeIcon icon={faCloudUploadAlt} /> Submit
                                                        </Button>

                                                        <Button
                                                            onClick={() => this.props.hideComponent({component: 'showList'})}
                                                            outline
                                                            color={"secondary"}>
                                                            <FontAwesomeIcon icon={faWindowClose} /> Cancel
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>
                                        }

                                        {!this.state.editStatus &&
                                        <div>
                                            <h4 className="card-title">View</h4>
                                            <p className="card-title-desc">&nbsp;</p>

                                            {this.state.fields ? this.state.fields.map((field, i) => {
                                                return (
                                                    <div key={i}>
                                                        <div className="row mb-3">
                                                            <span className="col-sm-2 col-4 col-form-label">
                                                                {field.name}
                                                            </span>
                                                            <span className="col-sm-10 col-8 col-form-label">

                                                                {(field.type === 'image' && this.state.formEdit[field.name] !== null) ?
                                                                    <img src={imgPath(this.state.formEdit[field.name])}
                                                                         alt={this.state.formEdit[field.name]}
                                                                         className='datatable_thumb'/>
                                                                    :
                                                                    this.state.formEdit[field.name]
                                                                }

                                                            </span>
                                                        </div>
                                                    </div>
                                                )
                                            }) : null}
                                            <div className="row mb-3">
                                                <div className="col-sm-2 col-4 col-form-label">&nbsp;</div>
                                                <div className="col-sm-10 col-8">
                                                    <Button outline
                                                            color="primary"
                                                            className="me-2"
                                                            item={this.props.id}
                                                            onClick={() => this.props.hideComponent({
                                                                component: 'showEdit',
                                                                db: this.props.db,
                                                                item: this.props.id,
                                                                return: 'showView'
                                                            })}>

                                                        <FontAwesomeIcon icon={faPencilAlt} /> Edit
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <Loader isLoading={true}/>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}

export default View;